"use client";

import { usePathname } from "next/navigation";

/**
 * Conditionally hides children when the current route matches
 * paths that have their own custom layout (e.g., ALP pages).
 */
export default function LayoutVisibility({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const hideForALP = pathname.startsWith("/whatuni-mobile-app");

  if (hideForALP) return null;
  return <>{children}</>;
}
